/**
 * Superpeak – "Ring mig op" popup.
 *
 * Modalen selv (med nonce og det hele) er server-renderet i footer.php,
 * så vi undgår at skulle hente en nonce via JS. Denne fil styrer bare
 * åbn/luk, og genåbner modalen med en fejlbesked, hvis afsendelsen gik galt.
 * Lykkes den, sender superpeak_handle_callback() i functions.php i stedet
 * kunden videre til tak-siden /tak-jeg-ringer-dig-op/.
 */

let modalEl = null;
let formStateEl = null;
let errorEl = null;

function lockScroll() {
	document.documentElement.classList.add( 'overflow-hidden' );
}

function unlockScroll() {
	document.documentElement.classList.remove( 'overflow-hidden' );
}

function openModal() {
	if ( ! modalEl ) {
		return;
	}
	modalEl.classList.remove( 'opacity-0', 'pointer-events-none' );
	lockScroll();
}

function closeModal() {
	if ( ! modalEl ) {
		return;
	}
	modalEl.classList.add( 'opacity-0', 'pointer-events-none' );
	unlockScroll();
}

function showFormState() {
	formStateEl.classList.remove( 'hidden' );
	errorEl.classList.add( 'hidden' );
}

function showErrorState() {
	formStateEl.classList.add( 'hidden' );
	errorEl.classList.remove( 'hidden' );
}

function bindEvents() {
	document.addEventListener( 'click', ( e ) => {
		if ( e.target.closest( '[data-callback-open]' ) ) {
			e.preventDefault();
			showFormState();
			openModal();
			return;
		}

		if ( e.target.closest( '[data-callback-close]' ) || e.target.id === 'callback-overlay' ) {
			closeModal();
		}
	} );

	document.addEventListener( 'keydown', ( e ) => {
		if ( e.key === 'Escape' ) {
			closeModal();
		}
	} );
}

/**
 * Går afsendelsen galt, redirecter superpeak_handle_callback() tilbage til
 * siden med ?opkald=fejl. Fanger vi det, åbner vi modalen igen med
 * fejlbeskeden, og rydder query-param'en op.
 */
function checkRedirectState() {
	const params = new URLSearchParams( window.location.search );
	const status = params.get( 'opkald' );

	if ( 'fejl' === status ) {
		showErrorState();
		openModal();
	} else {
		return;
	}

	params.delete( 'opkald' );
	const query = params.toString();
	const newUrl = window.location.pathname + ( query ? `?${ query }` : '' ) + window.location.hash;
	window.history.replaceState( {}, '', newUrl );
}

function init() {
	modalEl = document.getElementById( 'callback-modal' );
	if ( ! modalEl ) {
		return;
	}
	formStateEl = document.querySelector( '[data-callback-form-state]' );
	errorEl = document.querySelector( '[data-callback-error]' );

	bindEvents();
	checkRedirectState();
}

if ( document.readyState === 'loading' ) {
	document.addEventListener( 'DOMContentLoaded', init );
} else {
	init();
}
